let initiated = false;

export const pageView = () => {
  if (initiated) {
    ga("send", "pageview");
  }
};

export const setup = () => {
  (function (i, s, o, g, r, a, m) {
    i["GoogleAnalyticsObject"] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * (new Date() as any));
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "https://www.google-analytics.com/analytics.js",
    "ga"
  );

  var GA_LOCAL_STORAGE_KEY = "ga:clientId";
  const UAID = "UA-153523381-1";

  if (window.localStorage) {
    ga("create", UAID, {
      storage: "none",
      clientId: localStorage.getItem(GA_LOCAL_STORAGE_KEY),
    });
    ga(function (tracker) {
      localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get("clientId"));
    });
  } else {
    ga("create", UAID, "auto");
  }

  initiated = true;
  pageView();
};
